import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ErrorState } from './ErrorState';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

/**
 * ErrorBoundary global: captura errores de render, los loguea en consola
 * de forma estructurada y muestra ErrorState con opción de recargar.
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(
      JSON.stringify({
        level: 'error',
        message: 'render-error',
        timestamp: new Date().toISOString(),
        errorName: error.name,
        errorMessage: error.message,
        componentStack: info.componentStack,
      }),
    );
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-2xl px-4 py-16">
          <ErrorState
            title="Algo salió mal"
            description="Ocurrió un error inesperado. Puedes intentar recargar la página."
            onRetry={this.handleReload}
            retryLabel="Recargar página"
          />
        </div>
      );
    }
    return this.props.children;
  }
}
